__turbopack_context__.v({
  "chevron": "tile-module__ZHYXIq__chevron",
  "description": "tile-module__ZHYXIq__description",
  "media": "tile-module__ZHYXIq__media",
  "note": "tile-module__ZHYXIq__note",
  "poster": "tile-module__ZHYXIq__poster",
  "text": "tile-module__ZHYXIq__text",
  "tile": "tile-module__ZHYXIq__tile",
  "title": "tile-module__ZHYXIq__title",
});
